export const masterKeyValidator = (masterKey: string) => {

  if (masterKey.length !== 84) {
    return 'Invalid';
  }

  const regexp = /MMK((-)(.{1,})){7}/;

  if (!regexp.test(String(masterKey))) {
    return 'Invalid';
  }

  return null;
}
